<!-- Main Wrapper -->
<div class="mainContent">
  <!-- Header -->
  <div class="header">
    <label i18n="@@spmsUserReg" class="textColour">Business Logic</label>
    <span class="example-spacer"></span>
  </div>

  <!-- Scrollable Content Area -->
  <div class="content">
    <form novalidate >
      <div class="row" style="margin-top: 10px;">
        <div class="col-lg">
          <mat-form-field appearance="outline">
            <mat-label>Business Logic</mat-label>
                 <textarea style="height: 180px;"
                 matInput
                 placeholder="Business Logic"
                
                 required
                 rows="4"
                 [(ngModel)]="logic"
            ></textarea>
            <!-- <mat-error
              *ngIf="
                FormValid.controls['mappingtypename'].touched &&
                FormValid.controls['mappingtypename'].invalid
              "
            >
              Library Name is required.
            </mat-error> -->
            <!-- <mat-error
              *ngIf="
                FormValid.controls['mappingtypename'].touched &&
                FormValid.controls['mappingtypename'].hasError('pattern')
              "
            >
              Only letters, numbers, underscores (_) and hyphens (-) are
              allowed. Must include at least one letter or number.
            </mat-error> -->
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <!-- Footer Buttons -->
  <div class="footer">
    <div class="row">
      <div class="col-lg text-center">
        <div style="text-align: end;">
          <button
            i18n="@@TargetClear"
            type="button"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
            (click)="copyLogic()"
            style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;"
          >
            Copy
          </button>
          
          <button
            i18n="@@TargetCancel"
            type="button"
            class="btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
            [style.background-color]="buttonColor"
           (click)="cancel()"
            style="padding: .3rem 1.6rem; font-size: .85rem; width: 150px; color: white;"
          >
            Cancel
          </button>
        </div>
      </div>
    </div>
  </div>
</div>